import { render, staticRenderFns } from "./CompetitorPageRenderer.vue?vue&type=template&id=488a116a&scoped=true&"
import script from "./CompetitorPageRenderer.vue?vue&type=script&lang=js&"
export * from "./CompetitorPageRenderer.vue?vue&type=script&lang=js&"
import style0 from "./CompetitorPageRenderer.vue?vue&type=style&index=0&id=488a116a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488a116a",
  null
  
)

/* custom blocks */
import block0 from "./CompetitorPageRenderer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports